import Vue from 'vue'
import api from '@/apis/siteContact'
import {
  PROCESS_API_SUCCESS,
  PROCESS_API_FAILURE,
  GET_EMERGENCY_CONTACTS_REQUEST,
  GET_EMERGENCY_CONTACTS_SUCCESS,
  GET_EMERGENCY_CONTACTS_FAILURE
} from '@/store/mutation-types'
import parser from '@/models/siteContact'

let initialState = {
  emergencyContacts: [],
  status: {
    getEmergencyContacts: null
  },
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  emergencyContacts: function (state) {
    return state.emergencyContacts
  },
  statusGetEmergencyContacts: function (state) {
    return state.status.getEmergencyContacts
  }
}

// actions
const actions = {
  getEmergencyContacts: function ({ commit }, { siteId }) {
    commit(GET_EMERGENCY_CONTACTS_REQUEST)
    return new Promise((resolve, reject) => {
      api.getSiteContacts({siteId}).then(
        res => {
          let data = res.body
          commit(GET_EMERGENCY_CONTACTS_SUCCESS, { data })
          resolve(res)
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(GET_EMERGENCY_CONTACTS_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })

  }
}

// mutations
const mutations = {
  [GET_EMERGENCY_CONTACTS_REQUEST]: function (state) {
    state.status.getEmergencyContacts = "requested"
  },
  [GET_EMERGENCY_CONTACTS_SUCCESS]: function (state, { data }) {
    state.emergencyContacts = parser.parseContactsData(data)
    state.status.getEmergencyContacts = "successful"
  },
  [GET_EMERGENCY_CONTACTS_FAILURE]: function (state) {
    state.status.getEmergencyContacts = "failed"
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
